import { render, staticRenderFns } from "./ModeloCrud.vue?vue&type=template&id=f82f84a4&"
import script from "./ModeloCrud.vue?vue&type=script&lang=js&"
export * from "./ModeloCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports